import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import * as bottomNavigationActions from '../../actions/bottomNavigationActions';
import * as roomActions from '../../actions/roomActions';
import { withRoomContext } from '../../RoomContext';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Icons from '../SecondDoor/Common/Icons';
import * as meActions from '../../actions/meActions';

import { ROOM_TALKING, ROOM_OFFLINE } from '../../const';

import { firestore } from '../../lib/firebase';

const styles = () =>
	({
		root : {
			width           : '100%',
			maxWidth        : 1200,
			position        : 'relative',
			bottom          : 0,
			display         : 'flex',
			backgroundColor : '#f4f4f4',
			padding         : '0% 4%',
			alignItems      : 'center',
			zIndex          : 10,
			justifyContent  : 'center'
		},
		navi : {
			width                                                  : '50%',
			height                                                 : '96px',
			fontSize                                               : '1rem',
			color                                                  : '#999898',
			backgroundColor                                        : '#f4f4f4',
			'& .MuiButtonBase-root.MuiBottomNavigationAction-root' : {
				color : '#999898'
			},
			'& .MuiBottomNavigationAction-root.Mui-selected' : {
				backgroundColor         : '#e5e5e2',
				borderBottomRightRadius : '20px',
				borderBottomLeftRadius  : '20px',
				color                   : '#9ec317'
			}
		},
		logo : {
			width       : 'auto',
			height      : '30px',
			marginTop   : '2%',
			marginRight : '3%'
		},
		logout : {
			width                                                  : '10%',
			height                                                 : '100%',
			fontSize                                               : '1rem',
			color                                                  : '#999898',
			'& .MuiButtonBase-root.MuiBottomNavigationAction-root' : {
				color : '#999898'
			},
			backgroundColor : '#f4f4f4',
			marginLeft      : '3%'
		}
	});

const BottomNavi = ({
	room,
	info,
	roomClient,
	classes,
	setNaviTab,
	setUser,
	currentNaviTab,
	setAccessWarningDialogOpen,
	memo,
	currentMemo,
	setMemo,
	setCurrentMemo,
	resetRoom
}) =>
{
	const [ value, setValue ] = React.useState('recents');

	const handleChange = (event, newValue) =>
	{
		setValue(newValue);
		if (newValue === 'logout')
		{

			setNaviTab('home');
			setUser(null);
			setMemo(null);
			setCurrentMemo(null);
			// auth.signOut();
			roomClient.forceClose();

			if (room.name)
			{
				firestore.collection('rooms').doc(room.name)
					.update(
						{
							status : ROOM_OFFLINE,
							user   : ''
						}
					);

				resetRoom();
			}

		}
	};

	const handleChangeTab = useCallback((tab) =>
	{
		if (!info)
		{
			setAccessWarningDialogOpen(true);
		}
		else if (tab === 'call')
		{
			if (info.status === ROOM_TALKING)
			{
				setNaviTab(tab);
				setMemo(currentMemo);
			}
		}
		else
		{
			setNaviTab(tab);
			if (info.status === ROOM_TALKING)
			{
				console.log('memo', memo); // eslint-disable-line no-console
				setCurrentMemo(memo);
			}
		}
	}, [
		info,
		setNaviTab,
		setMemo,
		currentMemo,
		memo,
		setAccessWarningDialogOpen,
		setCurrentMemo ]);

	return (
		<Box
			mb={1}
			className={classes.root}
		>
			<img
				alt='logo'
				src='images/main_logo.png'
				className={classes.logo}
			/>
			<BottomNavigation
				showLabels
				value={currentNaviTab}
				onChange={(event, navTab) => handleChangeTab(navTab)}
				className={classes.navi}
			>
				<BottomNavigationAction label='通話' value='call' icon={<Icons category={'host'} iconName={'naviTalking'} type={info !== null && info.status === ROOM_TALKING ? 'active' : 'normal'} size={'1.5rem'}/>} />
				<BottomNavigationAction label='ホーム' value='home' icon={<Icons category={'host'} iconName={'naviHome'} type={currentNaviTab === 'home' ? 'active': 'normal'} size={'2rem'}/>} />
				<BottomNavigationAction label='メモ検索' value='memo' icon={<Icons category={'host'} iconName={'naviMemo'} type={currentNaviTab === 'memo' ? 'active': 'normal'} size={'1.5rem'}/>} />
				<BottomNavigationAction label='設　定' value='setting' icon={<Icons category={'host'} iconName={'naviSettings'} type={currentNaviTab === 'settings' ? 'active': 'normal'} size={'1.5rem'}/>} />
				<BottomNavigationAction label='TO DO' value='todo' icon={<Icons category={'host'} iconName={'naviTodo'} type={currentNaviTab === 'todo' ? 'active': 'normal'} size={'1.5rem'}/>} />
				<BottomNavigationAction label='着信履歴' value='calls' icon={<Icons category={'host'} iconName={'naviAbsent'} type={currentNaviTab === 'calls' ? 'active': 'normal'} size={'1.5rem'}/>} />
			</BottomNavigation>
			<BottomNavigation
				showLabels
				value={value}
				onChange={handleChange}
				className={classes.logout}
			>
				<BottomNavigationAction label='ログアウト' value='logout' icon={<Icons category={'host'} iconName={'naviLogout'} type={'normal'} size={'2rem'}/>} />
			</BottomNavigation>
		</Box>
	);
};

BottomNavi.propTypes =
{
	room                       : PropTypes.object.isRequired,
	info                       : PropTypes.object,
	roomClient                 : PropTypes.object.isRequired,
	classes                    : PropTypes.object.isRequired,
	bottomNavigation           : PropTypes.object.isRequired,
	setNaviTab                 : PropTypes.func.isRequired,
	setUser                    : PropTypes.func.isRequired,
	currentNaviTab             : PropTypes.string.isRequired,
	setAccessWarningDialogOpen : PropTypes.func.isRequired,
	memo                       : PropTypes.object,
	currentMemo                : PropTypes.object,
	setMemo                    : PropTypes.func.isRequired,
	setCurrentMemo             : PropTypes.func.isRequired,
	resetRoom                  : PropTypes.func.isRequired
};

const makeMapStateToProps = () =>
{
	const mapStateToProps = (state) =>
		({
			room             : state.room,
			info             : state.room.info,
			bottomNavigation : state.bottomNavigation,
			currentNaviTab   : state.bottomNavigation.currentNaviTab,
			memo             : state.room.memo,
			currentMemo      : state.room.currentMemo
		});

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch) =>
	({
		setNaviTab : (tab) =>
		{
			dispatch(bottomNavigationActions.setNaviTab(tab));
		},
		setUser : (user) =>
		{
			dispatch(meActions.setUser(user));
		},
		setAccessWarningDialogOpen : (accessWarningDialogOpen) =>
		{
			dispatch(roomActions.setAccessWarningDialogOpen(accessWarningDialogOpen));
		},
		setMemo : (memo) =>
		{
			dispatch(roomActions.setMemo(memo));
		},
		setCurrentMemo : (currentMemo) =>
		{
			dispatch(roomActions.setCurrentMemo(currentMemo));
		},
		resetRoom : () =>
		{
			dispatch(roomActions.resetRoom());
		}
	});

export default withRoomContext(connect(
	makeMapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.info === next.room.info &&
				prev.room.memo === next.room.memo &&
				prev.bottomNavigation.currentNaviTab === next.bottomNavigation.currentNaviTab
			);
		}
	}
)(withStyles(styles, { withTheme: true })(BottomNavi)));